import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CartDialogComponent } from "src/app/shared/cart/cart-dialog/cart-dialog.component";
import { ApiService } from "src/app/shared/services/api.service";
import { SubscriptionService } from "src/app/shared/services/subscription.service";
import { PopupComponent } from "../components/popup/popup.component";
import { isAllowToCreateOrderOrAddProduct } from "./util-functions";

@Injectable({
  providedIn: 'root'
})
export class OpenCartDialogs {

  constructor(
    private subscription: SubscriptionService,
    private apiService: ApiService,
    private dialog: MatDialog
  ) { }

  addToCart(store: Object, product: Object, check: boolean = true) {
    let isLoggedIn = this.apiService.loggedIn();
    // if check allow to create order (OR) add product start
    if (isLoggedIn && check) {
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: false })) {
        return;
      }
    }
    // if check allow to create order (OR) add product end
    product['msg'] = 2;
    if (store) {
      product['storeDetails'] = store;
    }
    const dialogRef = this.dialog.open(CartDialogComponent, {
      width: '450px',
      panelClass: 'product-dialog',
      data: product
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result['value'] === 'confirm' && result['logged'] === 'no') {
          this.subscription.subjectNext({ msg: "get shopping cart status bar data", closeProducDialog: true, refresh: true });
        }
        if (result['value'] === 'confirm' && result['logged'] === 'yes') {
          this.subscription.subjectNext({ refresh: true, closeProducDialog: true });
        }
      }
    });
  }

  editCart(store: Object, product: Object, check: boolean = true) {
    let isLoggedIn = this.apiService.loggedIn();
    // if check allow to create order (OR) add product start
    if (isLoggedIn && check) {
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: false })) {
        return;
      }
    }
    // if check allow to create order (OR) add product end
    var value;
    if (isLoggedIn === true) {
      product['msg'] = 2;
      value = product
    }
    if (isLoggedIn === false) {
      const cartData = JSON.parse(sessionStorage.getItem('cart'));
      var newproductValue = cartData.filter(val => val['product']['id'] === product['product']['id']);
      value = {};
      newproductValue[0]['msg'] = 1;
      newproductValue[0]['product']['compare_price'] = product['product']['compare_price'];
      value = newproductValue[0];
    }
    if (store) {
      value['storeDetails'] = store;
    }
    const dialogRef = this.dialog.open(CartDialogComponent, {
      width: '450px',
      panelClass: 'product-dialog',
      data: value
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result['value'] === 'confirm' && result['logged'] === 'no') {
          this.subscription.subjectNext({ msg: "get shopping cart status bar data", closeProducDialog: true });
        }
        if (result['value'] === 'confirm' && result['logged'] === 'yes') {
          this.subscription.subjectNext({ refresh: true });
        }
      }
    });
  }

  recurring(store: Object, user: Object, product: Object, check: boolean = true) {
    let isLoggedIn = this.apiService.loggedIn();
    // if check allow to create order (OR) add product start
    if (isLoggedIn && check) {
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: false })) {
        return;
      }
    }
    // if check allow to create order (OR) add product end
    let dateFormat = 'dd/MM/yyyy';
    if (store && store['date_format'] === 'm/d/Y') {
      dateFormat = 'MM/dd/yyyy';
    }
    product['msg'] = 2;
    product['currency'] = store['currency'];
    product['deliveryDay'] = user['delivery_day'];
    product['date-format'] = dateFormat;
    const dialogRef = this.dialog.open(PopupComponent, {
      maxWidth: '90vw',
      width: '360px',
      panelClass: 'product-dialog',
      data: {
        data: product,
        msg: 'edit subscription from products'
      }
    });
  }

  openDialog(store: Object, user: Object, product: Object) {
    let isLoggedIn = this.apiService.loggedIn();
    if (isLoggedIn) {
      // if check allow to create order (OR) add product start
      if (!isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, { yesBtn: true, noBtn: false })) {
        return;
      }
      // if check allow to create order (OR) add product end     
      this.addToCart(store, product, false);
    } else {
      let localCartProducts = JSON.parse(sessionStorage.getItem('cart'));
      let localCartProductIds = [];

      if (!!localCartProducts)
        localCartProductIds = localCartProducts.map(val => { return val['product']['id'] });

      if (localCartProductIds.length > 0 && localCartProductIds.indexOf(product['product']['id']) !== -1) {
        this.editCart(store, product)
      } else {
        this.addToCart(store, product);
      }
    }
    // console.log('product', product);
  }
}